import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import styles from "./Events.module.css";

export default function Events() {
  const navigate = useNavigate();

  return (
    <section className={styles.wrapper}>

      {/* HERO */}
      <motion.div
        className={styles.hero}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <span className={styles.kicker}>Book Our Space</span>
        <h1>
          Spaces Designed for <span>Joy, Creativity & Calm</span>
        </h1>
        <p>
          Thoughtfully created spaces for children’s celebrations and
          professional gatherings — warm, flexible and beautifully designed.
        </p>
      </motion.div>

      {/* BIRTHDAY EVENTS */}
      <motion.section
        className={`${styles.section} ${styles.pink}`}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className={styles.grid}>
          <div className={styles.text}>
            <h2>Birthdays & Celebrations</h2>

            <p className={styles.lead}>
              Make your child’s special day truly magical in a safe,
              joyful and supervised environment.
            </p>

            <ul className={styles.points}>
              <li>Exclusive access to indoor soft play area</li>
              <li>Private studio room for celebrations</li>
              <li>Safe & supervised play environment</li>
              <li>Ample space for kids to play freely</li>
            </ul>

            <h4>Perfect For</h4>
            <ul className={styles.points}>
              <li>Birthday parties</li>
              <li>Playdates & milestones</li>
              <li>Small private celebrations</li>
            </ul>

            <button
              className={styles.primaryBtn}
              onClick={() =>
                navigate("/contact", {
                  state: { enquiry: "Birthday Event" },
                })
              }
            >
              Enquire for Birthday Events
            </button>
          </div>

          <div className={styles.imageWrap}>
            <img
              src="https://images.unsplash.com/photo-1602631985686-1bb0e6a8696e?auto=format&fit=crop&w=1200&q=80"
              alt="Kids Birthday Celebration"
            />
          </div>
        </div>
      </motion.section>

      <div className={styles.divider} />

      {/* STUDIO */}
      <motion.section
        className={`${styles.section} ${styles.beige}`}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className={styles.gridReverse}>
          <div className={styles.imageWrap}>
            <img
              src="https://images.unsplash.com/photo-1517502884422-41eaead166d4?auto=format&fit=crop&w=1200&q=80"
              alt="Studio Room"
            />
          </div>

          <div className={styles.text}>
            <h2>Studio Room – Hourly Rental</h2>

            <p className={styles.lead}>
              A calm, well-lit studio space designed for focus,
              creativity and meaningful interaction.
            </p>

            <p className={styles.note}>
              Available for hourly booking (morning till 2 PM)
            </p>

            <ul className={styles.points}>
              <li>Yoga & fitness classes</li>
              <li>Counselling or therapy sessions</li>
              <li>Podcasts & content creation</li>
              <li>Workshops, meetings & training</li>
              <li>Comedy shows & small performances</li>
            </ul>

            <h4>Studio Features</h4>
            <ul className={styles.points}>
              <li>600–700 sq. ft. open space</li>
              <li>Calm, professional ambience</li>
              <li>Flexible layout</li>
              <li>Ideal for small groups or one-on-one</li>
            </ul>

            <button
              className={styles.darkBtn}
              onClick={() =>
                navigate("/contact", {
                  state: { enquiry: "Meeting" },
                })
              }
            >
              Enquire for Studio / Meeting
            </button>
          </div>
        </div>
      </motion.section>

      {/* FOOTER */}
      <motion.div
        className={styles.footer}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <p>
          ✨ Every space at Happy Horizon is designed to feel welcoming,
          safe and purposeful — for children, families and professionals alike.
        </p>
      </motion.div>
    </section>
  );
}
